import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'etranzact';

  ngOnInit(): void {
    // Bootstrap dropdown-menus inside a scrollable table container get clipped
    // by the container's overflow, especially when the table is short.
    // Temporarily relax the overflow while a dropdown within it is open.
    $(document).on('show.bs.dropdown', '.table-responsive, .table-div', function (this: any) {
      $(this).css('overflow', 'visible');
    });
    $(document).on('hide.bs.dropdown', '.table-responsive, .table-div', function (this: any) {
      $(this).css('overflow', '');
    });
  }
}
